import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  Property,
  SectionConfig,
} from '../../../../../dto/response/template.config';
import { TemplateConfigService } from '../../../../../service/template-config.service';

@Component({
  selector: 'app-footer-contact',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './footer-contact.component.html',
  styleUrl: './footer-contact.component.scss',
})
export class FooterContactComponent {
  @Input() icon: boolean = true;
  @Input() class: string;
  address: Property | undefined;
  email: Property | undefined;
  phone: Property | undefined;
  about: Property | undefined;
  _config!: SectionConfig;

  constructor(private templateConfigService: TemplateConfigService) { }

  @Input()
  set contactConfig(config: SectionConfig) {
    this._config = config;
    this.address = this.templateConfigService.findConfig(config, 'address');
    this.email = this.templateConfigService.findConfig(config, 'email');
    this.phone = this.templateConfigService.findConfig(config, 'phone');
    this.about = this.templateConfigService.findConfig(config, 'about');
  }

}
